import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { PlanoMelhoria } from "../models/plano-melhoria/planoMelhoria";
import { DefaultResponse } from "../models/DefaultResponse";
import { PlanoMelhoriaValidacao } from "../models/plano-melhoria/planoMelhoriaValidacao";
import { PlanoMelhoriaDivergencia } from "../models/plano-melhoria/planoMelhoriaDivergencia";

@Injectable({
  providedIn: 'root'
})

export class PlanoMelhoriaService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient) { }

  public getPlanoMelhoria(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.PlanoMelhoria.GetPlanoMelhoria}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPlanoMelhoriaPorDiretoriaEEscola(codigoDiretoria: number, codigoEscola: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.PlanoMelhoria.GetPlanoMelhoriaPorDiretoriaEEscola}?codigoDiretoria=${codigoDiretoria}&codigoEscola=${codigoEscola}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPlanoMelhoriaPorEscolaEStatus(codigoEscola: number, status: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.PlanoMelhoria.GetPlanoMelhoriaPorEscolaEStatus}?codigoEscola=${codigoEscola}&status=${status}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPlanoMelhoriaPorDiretoriaEStatus(codigoDiretoria: number, status: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.PlanoMelhoria.GetPlanoMelhoriaPorDiretoriaEStatus}?codigoDiretoria=${codigoDiretoria}&status=${status}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarPlanoMelhoria(parametros: PlanoMelhoria): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetCadastrarPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setAtualizarPlanoMelhoria(parametros: PlanoMelhoria): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetAtualizarPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setAprovarPlanoMelhoria(parametros: PlanoMelhoriaValidacao): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetAprovarPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setReprovarPlanoMelhoria(parametros: PlanoMelhoriaValidacao): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetReprovarPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setDeletePlanoMelhoria(parametros: PlanoMelhoria): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetDeletePlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public EnviarPlanoParaValidacao(parametros: PlanoMelhoria): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetEnviarPlanoParaValidacao}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarEvidenciaPlanoMelhoriaAcao(formData: FormData): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.SetCadastrarEvidenciaPlanoMelhoriaAcao}`, formData)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setArquivoBase64(formData: FormData): Observable<DefaultResponse> {

    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.setFileBase64}`, formData)
      .pipe(map((response: DefaultResponse) => response));
  }
  public getArquivoPorNome(nomeArquivo:string):Observable<Blob> {
    return this.http.get<Blob>(`${this.api.PlanoMelhoria.getArquivoPorNome}?nomeArquivo=${nomeArquivo}`, {responseType:  'blob' as 'json'})
    .pipe(map((response: Blob) => response));
  }

  public getPlanoMelhoriaDivergencias(somentePendentes = true): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.PlanoMelhoria.getPlanoMelhoriaDivergencias}?somentePendentes=${somentePendentes}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCadastrarDivergenciaVinculoPlanoMelhoria(parametros: PlanoMelhoriaDivergencia): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.setCadastrarDivergenciaVinculoPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setCorrigirVinculoPlanoMelhoria(parametros: PlanoMelhoriaDivergencia & { codigoUsuario: number; nomeUsuario: string; codigoPerfil: number; nomePerfil: string }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoMelhoria.setCorrigirVinculoPlanoMelhoria}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
}
